import { createClient, FunctionsHttpError } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Fail loudly in dev rather than silently issuing requests with an undefined URL.
  // eslint-disable-next-line no-console
  console.error("Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY -- copy .env.example to .env.local");
}

/** The browser NEVER holds a service-role key -- only the anon key, with RLS doing all
 *  the enforcement (docs/architecture.md section 14 rule 5, section 7). */
export const supabase = createClient(url ?? "", anonKey ?? "");

/**
 * supabase.functions.invoke()'s own error.message for a non-2xx response is a generic
 * "Edge Function returned a non-2xx status code" -- the useful text is JSON in the response
 * body (every function in supabase/functions returns { error: "..." } on failure). Used
 * wherever a screen calls a function directly (invite-member) instead of an RPC.
 */
export async function functionErrorMessage(err: unknown): Promise<string> {
  if (err instanceof FunctionsHttpError) {
    try {
      const body = await err.context.json();
      if (body?.error) return String(body.error);
    } catch {
      // fall through to the generic message below
    }
  }
  return err instanceof Error ? err.message : "Something went wrong.";
}
